import React from 'react'

const ChevronRightIcon = () => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5.30991 3.63828L9.4167 8.00005L5.30991 12.3617L6.28066 13.2757L11.248 8.00006L6.28067 2.72427L5.30991 3.63828Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default ChevronRightIcon
